
(function($, window, document) {

	// The $ is now locally scoped 

	// Listen for the jQuery ready event on the document
	$(function() { });

	Number.prototype.s_e_pad = function(size) {
	    var s = String(this);
	    while (s.length < (size || 2)) {s = "0" + s;}
	    return s;
	}


	$('.nae-home-highlight-slick').slick({
		dots: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 6000,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: false,
		fade: true,
  		cssEase: 'linear',
  		/*arrows: false*/
		prevArrow: '<span class="icon-arrow-left"></span>', 
		nextArrow: '<span class="icon-arrow-right"></span>',
		responsive: [
		    {
		      breakpoint: 480,
		      settings: {
		        arrows: false
		      }
		    },
    	]
		/* customPaging : function(slider, i) {
			var casas = slider.slideCount.toString().length;
			if(casas < 2){
				casas = 2;
			}
			return '<button type="button" role="tab" id="slick-slide-control0'+i+'" aria-controls="slick-slide0'+i+'" aria-label="1 of '+slider.slideCount +'" tabindex="" aria-selected="">'+(i + 1).s_e_pad(casas)+'</button>';
		} */

	});


	$('.nae-home-free-courses-slick').slick({
		dots: false,
		infinite: true,
		autoplay: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		centerMode: false,
		prevArrow: '<span class="icon-arrow-left"></span>', 
		nextArrow: '<span class="icon-arrow-right"></span>',
		responsive: [
		    {
		      breakpoint: 991,
		      settings: {
		        slidesToShow: 2,
		      }
		    },
		    {
		      breakpoint: 767,
		      settings: {
		        slidesToShow: 1,
		      }
		    },
    	]
		

	});


	$('.nae-structure-slick').slick({
		dots: true,
		infinite: true,
		autoplay: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		centerMode: true,
		centerPadding: 0,
		focusOnSelect: true,
		prevArrow: '<span class="icon-arrow-left"></span>', 
		nextArrow: '<span class="icon-arrow-right"></span>',
		

	});


	$('.nae-team-slick').slick({
		dots: true,
		infinite: true,
		autoplay: false,
		slidesToShow: 5,
		slidesToScroll: 1,
		centerMode: true,
		centerPadding: 0,
		focusOnSelect: true,
		prevArrow: '<span class="icon-arrow-left"></span>', 
		nextArrow: '<span class="icon-arrow-right"></span>',
		responsive: [
		    {
		      breakpoint: 1199,
		      settings: {
		        slidesToShow: 4,
				centerMode: false,
		      }
		    },
		    {
		      breakpoint: 768,
		      settings: {
		        slidesToShow: 3,
				centerMode: true,
		      }
		    },
    	]
		

	});


    
}(window.jQuery, window, document));